export default "__VITE_ASSET__9e65f201__"